import {
    ReactElement,
} from 'react';

import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useApplications} from '../hooks/useApplications.ts';
import {useApplicationsFilter} from '../hooks/useApplicationsFilter.ts';

import {
    RowSelectionDataCell,
    SimpleTableBatchAction,
    SimpleTablePagination,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {useApplicationsSelection} from '../hooks/useApplicationsSelection.ts';
import {IApplicationTableColumn,} from '../types';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useApplicationsPaging} from "../hooks/useApplicationsPaging.ts";
import {useApplicationsSearch} from "../hooks/useApplicationsSearch.ts";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = useApplicationsFilter();

    const {
        columns,
        visibleItems,
        loading,
    } = useApplications(filters);

    const {
        limit,
        totalPages,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useApplicationsPaging();

    const {
        handleFilterByKeyword,
    } = useApplicationsSearch();

    const {
        selection,
        handleRowSelection,
        handleSelectAllRows,
    } = useApplicationsSelection();
    const getColumns = () => {
        let cols: IApplicationTableColumn[] = [];
        if (allowedActions.includes('DeleteApplication')) {

            cols.push({
                          id: 'select',
                          title: '',
                          render: (item: any) => {
                              return <RowSelectionDataCell item={item} handleChange={() => handleRowSelection(item.id, !selection[item.id])}/>;
                          },


                      },
            );
        }

        cols = cols.concat(columns);

        return cols;

    };


    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={getColumns() as TableHeaderColumn[]}
                    handleSelectAllRows={() => handleSelectAllRows(!Object.keys(selection).length, visibleItems)}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={selection as any}
                    columns={getColumns() as TableBodyColumn[]}
                />
            </Table>

            <SimpleTablePagination
                totalPages={totalPages}
                visibleCount={totalCount}
                handlePageChange={handlePageChange}
            />
        </SimpleGrid>
    );
};
